import i18next from "i18next";

import {
  isValidDefaultLocale,
  isValidLocalePath,
  removePrefixLocale,
} from "@/lib/language";
import { join } from "@/lib/path";
import { useBeforeLeave, useNavigate } from "@solidjs/router";

export const routersLeave = () => {
  const navigate = useNavigate();

  useBeforeLeave((e) => {
    const formPathname = location.pathname;
    const to: string | number = e.to;
    let routerUrl = e.to as string;
    // 返回动作
    if (typeof to === "number") {
      routerUrl = e.from.pathname;
    }
    // 统一拦截自动添加lang前缀
    // 当前pathname有语言标识
    if (isValidLocalePath(formPathname)) {
      // 目标pathname无语言标识，自动添加语言标识
      if (!isValidLocalePath(routerUrl)) {
        e.preventDefault();
        navigate(join("/", i18next.language, routerUrl));
      }
    } else {
      // 当前pathname有默认语言标识，自动移除语言标识
      if (isValidDefaultLocale(routerUrl)) {
        e.preventDefault();
        navigate(join("/", removePrefixLocale(routerUrl)));
      }
    }
  });
};
